import React from "react";
import ICLock from "../assets/new/ic-lock.png";

export default function GameCard({ image, title, isLocked = false, onClick }) {
  return (
    <>
      <div className="game-card" onClick={onClick}>
        <div className="game-card__img">
          {isLocked && (
            <div className="lock-overlay">
              <img src={ICLock} alt="" />
            </div>
          )}

          <img src={image} alt="" />
        </div>
        <p className="game-card__content">{title}</p>
      </div>
    </>
  );
}
